export default __webpack_public_path__ + "static/media/ThePiano_05.17f3ab5e.png";